export class SuggestionGetEligible {
  static readonly type = '[Suggestion] Get Eligible';
}
export class SuggestionGetByMissingIds {
  static readonly type = '[Suggestion] Get by Id';
  constructor(public suggestionIds: string[]) {}
}
